module.exports = __webpack_public_path__ + "static/media/cellfinate_especialistas.76fcd93b.png";